import { DataService } from "../DataService/DataService";
import { ConceptStatus } from "../Enums/ConceptStatus";
import { ElementHelper } from "../Helpers/ElementHelper";
import { Toastr } from "../Helpers/Toastr";
import { AddOrUpdateSubmissionModel } from "../Models/AddOrUpdateSubmissionModel";
import { ModalTranslationTypes } from "../Models/ModalTranslationTypes";
import { IsSubmissionSubmitAllowedRequestModel } from "../Models/IsSubmissionSubmitAllowedRequestModel";
import { ModalManager } from "./ModalManager";
import { DateHelper } from "../Helpers/DateHelper";
import { AddConversionModel } from "../Models/AddConversionModel";
import { ConversionType } from "../Models/ConversionType";
import { EntityTypes } from "../Models/EntityTypes";

declare function initTinyMCE(selector):any
declare function destroyTinyMCE(selector):any

declare function cleanHTML(html):any
declare function clearHTML(html):any

declare function getTinyMCEContent():any
declare function getTinyMCEContentTextContent():any
declare function hideTinyMCEContainer():any
declare function showTinyMCEContainer():any
declare function setTinyMCEContent(content):any
export class ChallengeDetailManager {


    constructor(private containerElement: JQuery) {
    }

    private uploadPitchDisabledBackdrop : JQuery<HTMLElement>;
    private currentTarget : JQuery<HTMLElement>;
    private isUserFollowingChallenge : boolean;
    private challengeId : string;

    private editBriefingContainer : JQuery<HTMLElement>;
    private addUpdateContainer : JQuery<HTMLElement>;
    private meetupTabHeader : JQuery<HTMLElement>;

    public initialize() {
        let challengeId : string = this.containerElement.data('challenge-id');
        this.challengeId = challengeId;
        var autoFollowString = this.containerElement.data('auto-follow');
        let autoFollow : boolean = autoFollowString == "True" ? true : false;
        this.isUserFollowingChallenge = this.containerElement.data('is-user-following-challenge') == "True" ? true : false;

        var uploadTabHeaderElement = this.containerElement.find('#upload-tab-header');
        this.uploadPitchDisabledBackdrop = this.containerElement.find('.challenge-upload-pitch-disabled-backdrop');

        this.editBriefingContainer = this.containerElement.find('#edit-briefing-container');
        this.addUpdateContainer = this.containerElement.find('#add-update-container');

        this.meetupTabHeader = this.containerElement.find('#meetup-tab-header');

        var challengeUrl = this.containerElement.data('challenge-url');
        history.pushState(null, null, challengeUrl);

        ElementHelper.bindListItemsWithHref(this.containerElement);

        var self = this;
        var observer = new MutationObserver(function (events) {
            events.forEach(event => {
                var targetElement = $(event.target);

                if(self.currentTarget.attr('deta-tab') != targetElement.attr('deta-tab') && targetElement.hasClass('tab-block--active')) {
                    self.loadChallengeBlock(targetElement, challengeId, false, true);
                }
            });
        });

        this.containerElement.find('.tab-block').each((index, element) => {
            var tabBlock = $(element);
            observer.observe(element, {
                attributes: true, 
                attributeFilter: ['class'],
                childList: false, 
                characterData: false
            });

            if(tabBlock.hasClass('tab-block--active')) {
                self.loadChallengeBlock(tabBlock, challengeId);

                if(tabBlock.hasClass('upload-pitch-succeeded')) {
                    if (typeof (<any>window).gtag != "undefined") {
                        (<any>window).gtag('event', 'PitchUploadSuccess');
                    }
                }
            }
        });

        $('a[data-upload-pitch-button]').each((index, element) => {
            $(element).off('click').on('click', (e) => {
                var uploadSucceededElement = this.containerElement.find('div.upload-pitch-succeeded');
                if(uploadSucceededElement.length >= 1) {
                    uploadSucceededElement.removeClass("upload-pitch-succeeded");
                    self.loadChallengeBlock(uploadSucceededElement, challengeId, true);
                }
                else {
                    uploadTabHeaderElement.trigger('click');
                }
            });
        });

        var sendFollowConfirmedTracking = () => {
            if (typeof (<any>window).gtag != "undefined") {
                (<any>window).gtag('event', 'followChallenge');
            }
        };

        $('a[data-follow-challenge-button]').each((index, element) => {
            $(element).on('click', () => {
                
                ModalManager.loadModal(`?challengeId=${challengeId}&handler=FollowChallenge`, true, (modalContainer) => {
                    
                    var modalButton = modalContainer.find('button[data-type="submit"]');
                    var emailField = modalContainer.find('#email-field');
                    var form = modalContainer.find("form");
                    var v2verifyTokenInput = form.find('input[name="V2VerifyToken"]');
                    var v3verifyTokenInput = form.find('input[name="V3VerifyToken"]');
                    var v2Container = form.find('.recaptcha-v2');
                    var recaptchaVersion = 1;
                    var alertBox = modalContainer.find('#alert-box');

                    modalContainer.removeClass('fade');

                    form.off('submit').on('submit', (e) => {

                        e.preventDefault();
                        e.stopImmediatePropagation();

                        //TODO:"Submit form and get result"
                        var emailAddress = emailField.val().toString();

                        if(emailAddress.length == 0) {
                            emailField.addClass('input--red');
                            return;
                        }
                        else {
                            emailField.removeClass('input--red');
                        }

                        DataService.subscribeToParentForEmail(challengeId, 'Challenge', emailAddress, v2verifyTokenInput.val(), v3verifyTokenInput.val(), recaptchaVersion, (followResult) => {
                            recaptchaVersion = followResult.recaptchaVersion;

                            if(followResult.isEmailInvalid) {
                                emailField.addClass('input--red');
                                return;
                            }

                            if(followResult.errorTitle != undefined && followResult.errorMessage != undefined) {
                                Toastr.Error(followResult.errorTitle, followResult.errorMessage);
                                return;
                            }

                            if(!followResult.isAlreadyFollowing) {
                                if(!followResult.followResult && followResult.recaptchaVersion == 0) {
                                    v2Container.removeClass('d-none');
                                    modalButton.prop('disabled', true);
    
                                    alertBox.html(followResult.errorMessage);
                                    alertBox.addClass('show');   
                                    
                                    setTimeout(() => {
                                        alertBox.addClass('hide');
        
                                        setTimeout(() => {
                                            alertBox.removeClass('show');
                                            alertBox.removeClass('hide');
                                        }, 1000)
                                    }, 5000)
                                    return;
                                }
                            }


                            ModalManager.loadModal(`?challengeId=${challengeId}&followResult=${followResult.followResult}&isUserFollowingChallengeAlready=${followResult.isAlreadyFollowing}&handler=FollowChallengeResult`, true, () => {
                                $('a[data-already-following-challenge-button]').removeClass('d-none');
                                $('a[data-follow-challenge-button]').addClass('d-none');
                                self.isUserFollowingChallenge = true;
                                modalContainer.remove();

                                sendFollowConfirmedTracking();
                            });
                        })
                    });
                });
            });
        });

        $('a[data-already-following-challenge-button]').each((index, element) => {
                $(element).on('click', () => {
                    ModalManager.loadModal(`?challengeId=${challengeId}&handler=FollowChallengeResult`, true, (resultModalContainer) => {
                });
            });
        });

        $('a[data-follow-challenge-for-user-button]').each((index, element) => {
            $(element).on('click', () => {
                DataService.subscribeToParentForUser(challengeId, 'Challenge', (result) => {
                    if(result.errorTitle != undefined && result.errorMessage != undefined) {
                        Toastr.Error(result.errorTitle, result.errorMessage);
                    }

                    if(result.followResult) {
                        $('a[data-already-following-challenge-button]').removeClass('d-none');
                        $('a[data-follow-challenge-for-user-button]').addClass('d-none');
                        self.isUserFollowingChallenge = true;
                        sendFollowConfirmedTracking();
                    }
                });
            });
        });

        var uploadOnlyChallengeBriefContainer = $('div[data-upload-only-challenge-brief]');
        if(uploadOnlyChallengeBriefContainer.length >= 1) {
            self.loadChallengeBlock(uploadOnlyChallengeBriefContainer, challengeId);
        }

        if(autoFollow) {
            var followChallengeForUserButton = $('a[data-follow-challenge-for-user-button]').first();
            if(followChallengeForUserButton.length >= 1) {
                followChallengeForUserButton.trigger('click');
            }

            var followChallengeButton = $('a[data-follow-challenge-button]').first();
            if(followChallengeButton.length >= 1) {
                followChallengeButton.trigger('click');
            }
        }
        self.bindChallengeCountdown();
    }

    private bindChallengeCountdown() {
        var self = this;

        var daysTillDeadlineText = self.containerElement.find('#days-till-deadline-container');
        var hoursTillDeadlineText = self.containerElement.find('#hours-till-deadline-container');
        var minutesTillDeadlineText = self.containerElement.find('#minutes-till-deadline-container');

        var challengeHeader = $('body').find('.challenge-header').first();
        var deadlineYear = challengeHeader.data('deadline-year'); 
        var deadlineMonth = challengeHeader.data('deadline-month'); 
        var deadlineDay = challengeHeader.data('deadline-day'); 
        var deadlineHour = challengeHeader.data('deadline-hour'); 
        var deadlineMinute = challengeHeader.data('deadline-minute'); 

        var deadlineDateTime = new Date(deadlineYear, deadlineMonth-1, deadlineDay, deadlineHour, deadlineMinute);
        var deadlineTime  = deadlineDateTime.getTime()

        var dutchTimeZoneDate = new Date();
        dutchTimeZoneDate = DateHelper.changeTimezone(dutchTimeZoneDate, "Europe/Amsterdam")
        var currentDateTime = dutchTimeZoneDate.getTime();

        if(currentDateTime > deadlineTime) {
            return;
        }

        setInterval(() => {
            dutchTimeZoneDate = new Date();
            dutchTimeZoneDate = DateHelper.changeTimezone(dutchTimeZoneDate, "Europe/Amsterdam")
            currentDateTime = dutchTimeZoneDate.getTime();

            var difference = deadlineTime - currentDateTime;
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

            if(currentDateTime < deadlineTime) {
                daysTillDeadlineText.text(days);
                hoursTillDeadlineText.text(hours);
                minutesTillDeadlineText.text(minutes);
            }

        }, 1000)
    }

    public loadChallengeBlock(element: JQuery<any>, challengeId:string, forceReload : boolean = false, fromTabSwitch = false) {
        var self = this;
        var blockName = element.data('challenge-block-name');
        var submissionId = this.containerElement.data('submission-id');
        var readOnly : boolean = this.containerElement.data('read-only') ?? false;

        self.currentTarget = element;

        var url = '';
        if(submissionId.length == 0) {
            url = `?name=${blockName}&challengeId=${challengeId}&handler=Block`;
        }
        else {
            url = `?name=${blockName}&challengeId=${challengeId}&submissionId=${submissionId}&readOnly=${readOnly}&handler=Block`;
        }

        if(fromTabSwitch || (blockName==='challenge-upload-pitch' && forceReload)) {
            var tabUrl = element.data('challenge-tab-url');

            if(blockName==='challenge-upload-pitch') {
                tabUrl = tabUrl.replace('uploadsucceeded', 'upload');
            }

            history.pushState(null, null, tabUrl);            
        }

        if(blockName==='challenge-updates') {
            self.editBriefingContainer.removeClass('d-lg-flex');
            self.addUpdateContainer.addClass('d-lg-flex');
        }
        else if(blockName==='challenge-brief') {
            self.editBriefingContainer.addClass('d-lg-flex');
            self.addUpdateContainer.removeClass('d-lg-flex');
        }
        else {

            self.editBriefingContainer.removeClass('d-lg-flex');
            self.addUpdateContainer.removeClass('d-lg-flex');
        }

        var readmoreShadow = $('#briefing-readmore-shadow');

        if(element.children().length === 0 || forceReload) {
            element.load(url,
            () => {
                self.currentTarget.find('#meetup-button').each((index, element) => {
                    $(element).off('click').on('click', (e) => {
                        self.meetupTabHeader.trigger('click');  
                    });
                });



                if(blockName!=='challenge-brief') {
                    readmoreShadow.addClass('d-none');
                }


                if(blockName==='challenge-discussion') {
                    self.bindChallengeDiscussionsTab(self, challengeId, false, element);
                }
                else if(blockName==='challenge-upload-pitch') {
                    self.bindUploadForm(self, element, challengeId);
                }
                else if(blockName==='challenge-brief') {
                    self.bindChallengeBriefTab(self, element);
                } 
                else if(blockName==='challenge-meetup-form') {
                    self.bindChallengeMeetupFormTab(self, element);
                    
                    
                    var meetupForm = this.containerElement.find('#meetup-form');
                    if(meetupForm != undefined && meetupForm.length > 0) {
                        $('html, body').animate({
                            scrollTop: meetupForm.offset().top - 10
                        }, 50);
                    }
                }                 

                if(blockName==='challenge-upload-pitch') {
                    self.showUploadForm();

                    var uploadPitchForm = this.containerElement.find('#upload-pitch-form-content');
                    if(uploadPitchForm != undefined && uploadPitchForm.length > 0) {
                        $('html, body').animate({
                            scrollTop: uploadPitchForm.offset().top - 10
                        }, 50);
                    }
                }
                else {
                    self.hideUploadForm();
                }
            });

            return;
        }

        if(blockName==='challenge-brief') {
            readmoreShadow.removeClass('d-none');
        }
        else {
            readmoreShadow.addClass('d-none');
        }

        if(blockName==='challenge-discussion') {
            self.bindChallengeDiscussionsTab(self, challengeId, false, element);
        }

        if(blockName==='challenge-upload-pitch') {
            self.bindUploadForm(self, element, challengeId);

            self.showUploadForm();
        }
        else {
            self.hideUploadForm();
        }
    }

    private hideUploadForm() {
        var self = this;
        this.uploadPitchDisabledBackdrop.addClass('d-none');

        $('a[data-upload-pitch-button]').removeClass('d-none');

        if(self.isUserFollowingChallenge) {
            $('a[data-already-following-challenge-button]').removeClass('d-none');
        }
        else {
            $('a[data-follow-challenge-button]').removeClass('d-none');
            $('a[data-follow-challenge-for-user-button]').removeClass('d-none');
        }
    }

    private showUploadForm() {

        this.uploadPitchDisabledBackdrop.removeClass('d-none');

        $('a[data-upload-pitch-button]').addClass('d-none');
        $('a[data-follow-challenge-button]').addClass('d-none');
        $('a[data-follow-challenge-for-user-button]').addClass('d-none');
        $('a[data-already-following-challenge-button]').addClass('d-none');
    }

    public bindUploadForm(self : ChallengeDetailManager, uploadFormContainer : JQuery<Element>, challengeId:string) {
        var uploadPitchButton = uploadFormContainer.find('#submit-pitch-button');
        var submitButtonWrapper = uploadFormContainer.find('#submit-button-wrapper');
        var submitButtonSpinner = uploadFormContainer.find('#submit-button-spinner');
        var challengeDeadlineBanner = uploadFormContainer.find('.challenge-topbottom-banner');
        var uploadForm = uploadFormContainer.find('form');
        var invalidUploadFormInfoContainer = uploadFormContainer.find('#invalid-upload-form-info-container');

        var lastModifiedTimestampTicks = uploadForm.data('last-submission-modified-timestamp');

        var lastModifiedTimestampLabel = uploadFormContainer.find('#submission-last-modified-timestamp-label');
        var lastModifiedTimestampLabelParent = lastModifiedTimestampLabel.parent();

        var versionOutdatedFunc = ()=> {
            if (typeof (<any>window).gtag != "undefined") {
                (<any>window).gtag('event', 'submissionVersionOutdated');
            }

            DataService.getModalTranslations(ModalTranslationTypes.SubmissionVersionOutdated, (translationResult) => { 
                var confirmFunction = () => {
                    var submissionId = this.containerElement.data('submission-id');

                    const url = new URL(location.href); // new URL(document.URL)
                    let path = url.pathname.split("/");
                    path.pop(); // remove the last
                    path.push('upload');
                    url.pathname = path.join("/")
                    url.search = '';
                    if(submissionId.length > 0) {
                        url.search = 'submissionId='+submissionId;
                    }

                    location.href = url.href;
                };

                setTimeout(() => {
                    confirmFunction();
                }, 30000)
                
                if(translationResult == null) {
                    ModalManager.showModal('Versie concept inzending verouderd', 'De huidige versie van het formulier is verouderd. Waarschijnlijk doordat je ook in een andere browser-tab in dit formulier hebt gewerkt. Druk op de herlaad knop om te pagina opnieuw te laden. De meest recente formulier-data wordt dan voor je ingeladen. Deze pagina zal na 30 seconden automatisch herladen.', 'Formulier herladen', confirmFunction, true);
                }
                else {
                    ModalManager.showModal(translationResult.title, translationResult.body, translationResult.closeButton, confirmFunction, true);
                }
            });
        }

        var deadlineExpiredFunc = (status : ConceptStatus)=> {
            if (typeof (<any>window).gtag != "undefined") {
                (<any>window).gtag('event', 'addOrUpdateSubmissionValueWhileDeadlineExpired');
            }
            
            var translationType = status == ConceptStatus.Concept ? ModalTranslationTypes.ChallengeDeadlineExpiredWhileUpdatingConceptSubmission : ModalTranslationTypes.ChallengeDeadlineExpiredWhileUpdatingSubmittedSubmission;

            DataService.getModalTranslations(translationType, (translationResult) => { 
                var confirmFunction = () => {
                    var returnUrl = uploadPitchButton.data('return-url');

                    if(status == ConceptStatus.Submitted && returnUrl != undefined && returnUrl.length > 0)  {
                        location.href = returnUrl;
                    }
                    else {
                        const url = new URL(location.href);
                        let path = url.pathname.split("/");
                        path.pop(); // remove the last
                        path.push('upload');
                        location.href = url.href;
                    }

                };

                setTimeout(() => {
                    confirmFunction();
                }, 30000)
                
                if(translationResult == null) {
                    ModalManager.showModal('Deadline verlopen', 'De deadline van de challenge is verlopen. Je inzending kan helaas niet meer ingediend worden.', 'Ok', confirmFunction, true);
                }
                else {
                    ModalManager.showModal(translationResult.title, translationResult.body, translationResult.closeButton, confirmFunction, true);
                }
            });
        }

        var validateSubmissionFunc = () => {
            var submissionId = uploadForm.data('submission-id');
            if(submissionId != undefined && submissionId.length>0) {

                uploadPitchButton.attr('disabled', 'disabled');
                submitButtonSpinner.removeClass('visibility-hidden');
                invalidUploadFormInfoContainer.removeClass('visibility-hidden');

                DataService.isSubmissionValid(submissionId, (result) => {
                    if(result) {
                        invalidUploadFormInfoContainer.addClass('visibility-hidden');
                        uploadPitchButton.removeAttr('disabled');
                    }

                    submitButtonSpinner.addClass('visibility-hidden');
                })                
            }

        }

        if(challengeDeadlineBanner != undefined && challengeDeadlineBanner.length > 0) {
            this.bindDeadlineBanner(challengeDeadlineBanner, uploadForm, deadlineExpiredFunc);
        }
        validateSubmissionFunc();

        uploadPitchButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            uploadPitchButton.attr('disabled', 'disabled');
            submitButtonWrapper.attr('disabled', 'disabled');
            submitButtonSpinner.removeClass('visibility-hidden');

            uploadForm.find(':input:not([type="file"])').each((index, element) => {
                var formElement = $(element);
                var formElementValue = formElement.val();

                if(formElementValue != undefined) {
                    formElement.val(cleanHTML(formElementValue));
                }
            })

            var submissionId = uploadForm.data('submission-id');

            if(submissionId != undefined && submissionId.length > 0) {
                var isSubmitAllowedModel = new IsSubmissionSubmitAllowedRequestModel();
                isSubmitAllowedModel.submissionId = submissionId;
                isSubmitAllowedModel.lastModifiedTimestampTicks = lastModifiedTimestampTicks;

                DataService.isSubmissionSubmitAllowed(challengeId, isSubmitAllowedModel, (result) => {
                    if(result.versionOutdated) {
                        versionOutdatedFunc();
                    }
                    else if(result.deadlineExpired) {
                        deadlineExpiredFunc(result.status);
                    }
                    else {
                        var addConversionModel = new AddConversionModel();
                        addConversionModel.type = ConversionType.SubmissionSubmitButtonClick;
                        addConversionModel.parentId = this.challengeId;
                        addConversionModel.parentType = EntityTypes.Challenge;
        
                        DataService.addConversion(addConversionModel, () => {
        
                        })
                        
                        uploadForm.trigger('submit');
                    }
                });
            }
            else {
                var addConversionModel = new AddConversionModel();
                addConversionModel.type = ConversionType.SubmissionSubmitButtonClick;
                addConversionModel.parentId = this.challengeId;
                addConversionModel.parentType = EntityTypes.Challenge;

                DataService.addConversion(addConversionModel, () => {

                })

                uploadForm.trigger('submit');
            }
        })

        var submitButtonWrapperClickAllowed = true;
        submitButtonWrapper.off('click').on('click', () => {
            if(submitButtonWrapperClickAllowed) {

                submitButtonWrapperClickAllowed = false;
                setTimeout(() => {
                    submitButtonWrapperClickAllowed = true;
                }, 5000)
                
                var uploadFormInputs = uploadForm.find('.upload-form-group-box').find(':input');
                var submissionId = uploadForm.data('submission-id');

                submitButtonSpinner.removeClass('visibility-hidden');
                var scrolledToError = false;

                uploadFormInputs.each((index, element) => {
                    var input = $(element); 
                    var elementId = input.attr('id');
                    if(elementId?.indexOf('[') != -1) {
                        elementId = input.attr('name');
                    }

                    var uploadPitchFormItem = input.closest('.upload-pitch-form-item');
                    var warningTextContainer = uploadPitchFormItem.find('.warning-text-container');
                    var infoCircleContainer = uploadPitchFormItem.find('.upload-pitch-form-item-info-circle-container');

                    if(elementId != undefined) {
                        DataService.validateSubmissionValue(submissionId, elementId, (result) => {
                            if(result.success) {    
                                warningTextContainer.addClass('d-none');
                                input.removeClass('input--red')
        
                                uploadPitchFormItem.find('.title-label').removeClass('warning-text');
                                uploadPitchFormItem.removeClass('invalid-upload-form-item');
                            }
                            else {
                                uploadPitchFormItem.addClass('invalid-upload-form-item');
                                warningTextContainer.removeClass('d-none');
                                uploadPitchFormItem.find('.title-label').addClass('warning-text')
                                input.addClass('input--red')
        
                                if(result.message != undefined) {
                                    warningTextContainer.find('.warning-text-label').text(result.message);
                                    warningTextContainer.find('.warning-text-label').val(result.message);
                                    warningTextContainer.find('.warning-text-label').html(result.message);
                                }

                                if(!scrolledToError) {
                                    scrolledToError = true;
                                    $('html, body').animate({
                                        scrollTop: uploadPitchFormItem.offset().top - 10
                                    }, 50);
                                }
                            }
    
                            var infoCircleIcon = infoCircleContainer.find('i');
                            infoCircleIcon.removeClass();
    
                            if(result.success) {
                                if(!input.is(":checkbox")) {
                                    infoCircleIcon.addClass('fas fa-check-circle color-success');
                                }
                            }
                            else {
                                infoCircleIcon.addClass('fas fa-hand-point-right color-warning');
                            }
                        })
                    }
                }) 

                validateSubmissionFunc();
            }

        })

        uploadForm.find('.upload-form-group-box').find(':input').each((index, element) => {
            var input = $(element);
            var elementId = input.attr('id');

            input.off();

            var inputTimeout;

            

            var updateSubmissionFunction = (e, properties) => {
                uploadPitchButton.attr('disabled', 'disabled');

                submitButtonSpinner.removeClass('visibility-hidden');
                invalidUploadFormInfoContainer.removeClass('visibility-hidden');

                var submissionId = uploadForm.data('submission-id');

                var formData = new FormData();  
                formData.append('submissionId', submissionId)
                formData.append('lastModifiedTimestamp', lastModifiedTimestampTicks)
                if(elementId != undefined) {
                    formData.append('itemId', elementId.toString())
                }

                if(properties != undefined && properties.skipVersionCheckPopup) {
                    formData.append('skipVersionCheck', 'true');
                }

                if(input.is(":file")) {
                    var maxFileSize = +input.data('max-file-size');
                    var labelElement = uploadForm.find(`#label_${elementId}`).children().first();
                    var inputElement = e.target as HTMLInputElement;
                    var fileName = labelElement.text();
                    var removeFileButton = input.closest('.upload-pitch-form-file-item').find('#remove-file-button');
                    var fileSpinner = input.closest('.upload-pitch-form-file-item').find('#file-spinner');

                    var file = inputElement.files[0];
                    if(file != undefined) {

                        fileSpinner.removeClass('d-none');
                        removeFileButton.addClass('d-none');
                        labelElement.text('');

                        if (file.size > maxFileSize) {
    
                            Toastr.Warning('File too large', `Maximum upload size is ${maxFileSize / 1024 / 1024} Mb.`);
                            inputElement.value = null;
                            fileSpinner.addClass('d-none');
        
                            return;
                        }

                        fileName = file.name;

                        var isImage = file['type'].includes('image');

                        if(isImage) {
                            var reader = new FileReader();
                        
                            reader.onload = function(e) {
                              var thumbnailDiv = input.closest('.upload-pitch-form-file-item').find('#image-thumbnail-container');
                              thumbnailDiv.attr('src', e.target.result.toString());
                              //thumbnailDiv.css("background-image", "url('" + e.target.result.toString() + "')");
                            }
                            
                            reader.readAsDataURL(file); // convert to base64 string
                        }
                    }

                    if(elementId != undefined) {
                        if(file != undefined) {
                            formData.append(elementId, file, fileName);  
                        }
                        else {
                            formData.append(elementId, fileName);  
                            formData.append('IsForFileValidCheck', 'true');  
                        }
                        
                    }
                }
                else if(input.is(":checkbox")) {
                    var parentContainer = input.parent();

                    var valueToSet = ``; 

                    parentContainer.find('input:checked').each(function() {
                        valueToSet += `${$(this).val()};`;
                    });

                    valueToSet = valueToSet.slice(0,-1);

                    if(elementId != undefined) {
                        formData.append(elementId, valueToSet);  
                    }
                }
                else {
                    var inputElementValue = input.val();
                    if(inputElementValue != undefined) {
                        input.val(cleanHTML(inputElementValue));
                        if(elementId != undefined) {
                            formData.append(elementId, inputElementValue.toString());  
                        }
                    }
                }

                DataService.addOrUpdateSubmission(challengeId, formData, (result) => {
                    var uploadPitchFormItem = input.closest('.upload-pitch-form-item');
                    var warningTextContainer = uploadPitchFormItem.find('.warning-text-container');
                    var infoCircleContainer = uploadPitchFormItem.find('.upload-pitch-form-item-info-circle-container');
                    var removeFileButton = uploadPitchFormItem.find('#remove-file-button');

                    if(result.versionOutdated) {
                        if(properties == undefined || (properties != undefined && properties.skipVersionCheckPopup == false)) {
                            versionOutdatedFunc();
                        }
                    }
                    else if(result.deadlineExpired) {
                        deadlineExpiredFunc(result.status);
                    }
                    else if(result.submissionId != undefined) {
                        if(uploadPitchFormItem.hasClass('upload-pitch-form-hyperlink-item')) {
                            input.val(result.value);
                        }

                        if(result.success) {
                            uploadForm.data('submission-id', result.submissionId.toString());
    
                            warningTextContainer.addClass('d-none');
                            input.removeClass('input--red')
    
                            uploadPitchFormItem.find('.title-label').removeClass('warning-text');
                            uploadPitchFormItem.removeClass('invalid-upload-form-item');

                            if(input.is(":file")) {
                                var filePreviewLink = input.closest('.upload-pitch-form-file-item').find('#file-preview-link');
                                if(submissionId != undefined && elementId != undefined) {
                                    fileSpinner.addClass('d-none');
                                    filePreviewLink.attr('href', `/file/${result.submissionId}/fileitem/${elementId}`);
                                    filePreviewLink.text(file.name);
                                    removeFileButton.removeClass('d-none');
                                }
                            }
                        }
                        else {
                            uploadPitchFormItem.addClass('invalid-upload-form-item');
                            warningTextContainer.removeClass('d-none');
                            uploadPitchFormItem.find('.title-label').addClass('warning-text')
                            input.addClass('input--red')
    
                            if(result.message != undefined) {
                                warningTextContainer.find('.warning-text-label').text(result.message);
                                warningTextContainer.find('.warning-text-label').val(result.message);
                                warningTextContainer.find('.warning-text-label').html(result.message);
                            }

                            if(input.is(":file")) {
                                var labelElement = uploadForm.find(`#label_${elementId}`).children().first();
                                var inputElement = e.target as HTMLInputElement;
                                inputElement.value = null;
                                labelElement.text('');
                                removeFileButton.addClass('d-none');
                                fileSpinner.addClass('d-none');
                            }
                        }

                        var infoCircleIcon = infoCircleContainer.find('i');
                        infoCircleIcon.removeClass();

                        if(result.success) {
                            
                            if(input.is('select')) {
                                if(input.val() == '00000000-0000-0000-0000-000000000000') {
                                    infoCircleIcon.addClass('fas fa-hand-point-right color-warning');
                                }
                                else {
                                    infoCircleIcon.addClass('fas fa-check-circle color-success');
                                }
                            }
                            else if(!input.is(":checkbox")) {
                                infoCircleIcon.addClass('fas fa-check-circle color-success');
                            }
                        }
                        else {
                            infoCircleIcon.addClass('fas fa-hand-point-right color-warning');
                        }

                        if(result.lastModifiedTimestampTicks != undefined) {
                            lastModifiedTimestampTicks = result.lastModifiedTimestampTicks.toString();
                            uploadForm.data('last-submission-modified-timestamp', result.lastModifiedTimestampTicks.toString())
                        }
                        else {
                            lastModifiedTimestampTicks = '';
                        }
    
                        lastModifiedTimestampLabel.text(result.lastModifiedTimestampString);
                        lastModifiedTimestampLabelParent.removeClass('visibility-hidden');

                        if(properties == undefined || (properties != undefined && !properties.skipIsSubmissionValidCheck)) {
                            validateSubmissionFunc();
                        }
                        
                    }
                });
            }

            if(input.hasClass('btn--upload')) {
                var fileInput = input.parent().find('.file');
                console.log(fileInput);

                input.off('click').on('click', (e) => {
                    e.preventDefault();
                    fileInput.trigger('click');
                });
            }
            else if(input.attr('type') === 'text') {
                var inputCharacterCounter = input.closest('.upload-pitch-form-item').find('.character-counter-element');
                var maxLength = +inputCharacterCounter?.data('max-length') ?? 0;

                var updateCharacterCountFunc = () => {
                    var valueLength = input.val()?.toString().length;
                    inputCharacterCounter.text(`(${valueLength}/${maxLength})`);
                };

                if(inputCharacterCounter != undefined && inputCharacterCounter.length > 0 && maxLength > 0) {
                    updateCharacterCountFunc();
                } 

                input.on('input', (e, properties) => {
                    uploadPitchButton.attr('disabled', 'disabled');
                    invalidUploadFormInfoContainer.removeClass('visibility-hidden');
                    submitButtonSpinner.removeClass('visibility-hidden');

                    if(inputCharacterCounter != undefined && inputCharacterCounter.length > 0 && maxLength > 0) {
                        updateCharacterCountFunc();
                    } 
    
                    if (inputTimeout) {
                        clearTimeout(inputTimeout);
                    }
    
                    inputTimeout = setTimeout(() => { 
                        updateSubmissionFunction(e, properties);
                    }, 500);
                })

                input.on('change', (e, properties) => {
                    if(properties != undefined && properties.submitButtonWrapperClick == true) {
                        updateSubmissionFunction(e, properties);
                    }
                });
                
            }
            else {
                input.on('change', (e, properties) => {
                    updateSubmissionFunction(e, properties);
                });

                if(input.attr('type') === 'file') {
                    var filePreviewLink = input.closest('.upload-pitch-form-file-item').find('#file-preview-link');
                    var removeFileButton = input.closest('.upload-pitch-form-file-item').find('#remove-file-button');
                    var submissionId = uploadForm.data('submission-id');
                    var elementId = input.attr('id');

                    if(submissionId != undefined && elementId != undefined) {
                        filePreviewLink.attr('href', `/file/${submissionId}/fileitem/${elementId}`);

                        var imageDiv = input.closest('.upload-pitch-form-file-item').find('#image-thumbnail-container');
                        if(imageDiv != undefined && imageDiv.length > 0 && (imageDiv.attr('src') != '')) {
                            removeFileButton.removeClass('d-none');
                        }
                        else if(filePreviewLink.text().length > 0) {
                            removeFileButton.removeClass('d-none');
                        }
                    }

                    removeFileButton.on('click', () => {
                        if(elementId == undefined) {
                            location.reload();
                            return;
                        }

                        removeFileButton.prop('disabled', true);

                        var formData = new FormData();  
                        formData.append('submissionId', submissionId);
                        formData.append('lastModifiedTimestamp', lastModifiedTimestampTicks)
                        formData.append('itemId', elementId.toString())

                        DataService.deleteSubmissionFile(challengeId, formData, (result) => {
                            var uploadPitchFormItem = input.closest('.upload-pitch-form-item');
                            var warningTextContainer = uploadPitchFormItem.find('.warning-text-container');
                            var infoCircleContainer = uploadPitchFormItem.find('.upload-pitch-form-item-info-circle-container');
        
                            if(result.versionOutdated) {
                                versionOutdatedFunc();
                            }
                            else if(result.deadlineExpired) {
                                deadlineExpiredFunc(result.status);
                            }
                            else if(result.submissionId != undefined) {
                                removeFileButton.addClass('d-none');
                                filePreviewLink.text('');
                                input.closest('.upload-pitch-form-file-item').find('#image-thumbnail-container').attr('src', '');

                                if(result.success) {
                                    uploadForm.data('submission-id', result.submissionId.toString());
            
                                    warningTextContainer.addClass('d-none');
                                    input.removeClass('input--red')
            
                                    uploadPitchFormItem.find('.title-label').removeClass('warning-text');
                                    uploadPitchFormItem.removeClass('invalid-upload-form-item');
                                }
                                else {
                                    uploadPitchFormItem.addClass('invalid-upload-form-item');
                                    warningTextContainer.removeClass('d-none');
                                    uploadPitchFormItem.find('.title-label').addClass('warning-text')
                                    input.addClass('input--red')
            
                                    if(result.message != undefined) {
                                        warningTextContainer.find('.warning-text-label').text(result.message);
                                        warningTextContainer.find('.warning-text-label').val(result.message);
                                        warningTextContainer.find('.warning-text-label').html(result.message);
                                    }
                                }
        
                                var infoCircleIcon = infoCircleContainer.find('i');
                                infoCircleIcon.removeClass();
        
                                if(result.success) {
                                    infoCircleIcon.addClass('fas fa-check-circle color-success');
                                }
                                else {
                                    infoCircleIcon.addClass('fas fa-hand-point-right color-warning');
                                }
        
                                input.val('');
        
                                if(result.lastModifiedTimestampTicks != undefined) {
                                    lastModifiedTimestampTicks = result.lastModifiedTimestampTicks.toString();
                                }
                                else {
                                    lastModifiedTimestampTicks = '';
                                }
            
                                lastModifiedTimestampLabel.text(result.lastModifiedTimestampString);
                                lastModifiedTimestampLabelParent.removeClass('visibility-hidden');
        
                                validateSubmissionFunc();
                            }
                        });
                    });
                }
            }
        })
    }

    public bindChallengeDiscussionsTab(self : ChallengeDetailManager, challengeId: string, forChildItem: boolean = false, container : JQuery<HTMLElement>) {
        var orgNameForResponseDiv = container.find('#organization-name-for-response');
        var anonymousNameForResponseDiv = container.find('#anonymous-name-for-response');

        var anonymousCheckbox = container.find('input:checkbox');
        anonymousCheckbox.on('change', () => {
            if(anonymousCheckbox.is(':checked')) {
                orgNameForResponseDiv.addClass('d-none');
                anonymousNameForResponseDiv.removeClass('d-none');
            }
            else {
                anonymousNameForResponseDiv.addClass('d-none');
                orgNameForResponseDiv.removeClass('d-none');
            }
        })

        container.find('div[data-discussion-id]').each((index, element) => {
            
            var discussionItem = $(element);
            var discussionId = discussionItem.data('discussion-id');

            var respondDiv = discussionItem.find(`#respond-to-discussion-${discussionId}`);

            var editOrRespondFunction = () => {
                var responseContainer = respondDiv.find('.respond-to-discussion-container').first();
                if(responseContainer != undefined) {
                    var containerId = `#${responseContainer.attr('id')}`;
                    destroyTinyMCE(containerId);

                    initTinyMCE(containerId);
                }

                this.bindChallengeDiscussionsTab(self, challengeId, true, respondDiv);
            }

            var respondButton = discussionItem.find('a[data-respond-button]');
            respondButton.off('click').on('click', () => {

                respondDiv.load(`?discussionId=${discussionId}&challengeId=${challengeId}&handler=RespondToDiscussion`, () => {
                    editOrRespondFunction();

                });
            });
            
            discussionItem.find('a[data-edit-response-button]').off('click').on('click', () => {
                respondDiv.load(`?discussionId=${discussionId}&challengeId=${challengeId}&handler=EditDiscussionItem`, () => {
                    editOrRespondFunction();
                });
            });

            discussionItem.find('a[data-remove-response-button]').off('click').on('click', () => {
                DataService.getModalTranslations(ModalTranslationTypes.RemoveDiscussionItem, (translationResult) => { 
                    var confirmFunction = () => {
                        DataService.removeDiscussionItem(challengeId, discussionId, (result) => {
                            location.reload();
                        })
                    };
                    
                    if(translationResult == null) {
                        ModalManager.showModal('Reactie verwijderen', 'Wil je echt deze reactie verwijderen? Dit kan niet teruggedraaid worden', 'bevestigen', confirmFunction);
                    }
                    else {
                        ModalManager.showModal(translationResult.title, translationResult.body, translationResult.closeButton, confirmFunction);
                    }
                });

            });

            discussionItem.find('a[data-set-as-answered]').off('click').on('click', () => {
                DataService.getModalTranslations(ModalTranslationTypes.SetDiscussionItemAsAnswered, (translationResult) => { 
                    var confirmFunction = () => {
                        DataService.setDiscussionItemAsAnswered(challengeId, discussionId, (result) => {
                            location.reload();
                        })
                    };
                    
                    if(translationResult == null) {
                        ModalManager.showModal('Reactie als beantwoord markeren', 'Wil je echt deze reactie echt als beantwoord markeren? Dit kan niet teruggedraaid worden', 'bevestigen', confirmFunction);
                    }
                    else {
                        ModalManager.showModal(translationResult.title, translationResult.body, translationResult.closeButton, confirmFunction);
                    }
                });
            });

        });

        if(!forChildItem) {
            initTinyMCE('#ask-question-container');
        }

        container.find('form').each((index, element) => {
            var formElement = $(element);
            var submitButton = formElement.find('button[type="submit"]');

            formElement.off('submit').on('submit', (e) => {
                var textArea = formElement.find('textarea');
                submitButton.prop('disabled', true);

                var value = textArea.val();
                if(value === '' || value == undefined) {
                    e.preventDefault();
                    if(forChildItem) {
                        Toastr.Error('No response filled in', 'Please fill in your response!');
                    }
                    else {
                        Toastr.Error('No question filled in', 'Please fill in your question!');
                    }

                    submitButton.prop('disabled', false);
                    return false;
                }
                else {
                    textArea.val(cleanHTML(value.toString()));
                    return true;
                }
            });
        });


    }


    public bindChallengeBriefTab(self : ChallengeDetailManager, tab : JQuery<Element>) {
        var challengeBrief = tab.find('.challenge-brief');
        var collapse = tab.find('#cb_collapse');
        var collapseBox = tab.find('#cb_collapsebox');

        var readMoreButton = tab.find('.collapse-button');
        var readmoreShadow = $('#briefing-readmore-shadow');
        var readmorePosition = self.containerElement.height();

        var challengeBriefContentHeight = collapse.children().first().height();
        if(challengeBriefContentHeight != undefined && readmorePosition != undefined && challengeBriefContentHeight > 0) {
            var newCollapseHeight = challengeBriefContentHeight / 100 * 85;
            collapse.css('height', newCollapseHeight + 10);

            readmorePosition -= 60;

            //This removes the height
            readmorePosition -= 50;

            readmoreShadow.css('top', readmorePosition);
            readmoreShadow.removeClass('d-none');
            //collapseBox.css('height', newCollapseHeight + 15);
        }

        var collapseHeight = collapse.height();
        if(collapseHeight != undefined && collapseHeight <= 350) {
            collapseBox.remove();
            readmoreShadow.remove();
            collapse.addClass('show');
            collapse.css('height', '');
        }
        else {
            collapse.on('show.bs.collapse', () => {
                readmoreShadow.remove();
            });

            collapse.on('shown.bs.collapse', () => {
                collapseBox.remove();
                
                var addConversionModel = new AddConversionModel();
                addConversionModel.type = ConversionType.ChallengeBriefingReadMoreClick;
                addConversionModel.parentId = this.challengeId;
                addConversionModel.parentType = EntityTypes.Challenge;

                DataService.addConversion(addConversionModel, () => {

                })
    
                if (typeof (<any>window).gtag != "undefined") {
                    (<any>window).gtag('event', 'readmoreChallenge');
                }
            });
        }
    }

    //#region Meetup form

    public bindChallengeMeetupFormTab(self : ChallengeDetailManager, tab : JQuery<Element>) {
        var container = tab.find('.challenge-meetup-form');

        var bindMeetupTabFunction = () => {
            var form = container.find("form");
            var submitButton = form.find('button[type="submit"]');
            var newsletterErrorContainer = form.find('.meetup-error-container');
            var submitButtonSpinner = form.find('#submit-button-spinner');
            newsletterErrorContainer.addClass('meetup-error-container-show');
    
            setTimeout(() => {
                newsletterErrorContainer.removeClass('meetup-error-container-show');
            }, 5000)

            form.off('submit').on('submit', () => {
                submitButton.prop('disabled', true);
                submitButtonSpinner.removeClass('d-none');

                form.find(':input').each((index, element) => {
                    var formElement = $(element);
                    var formElementValue = formElement.val();
    
                    if(formElementValue != undefined) {
                        formElement.val(clearHTML(formElementValue));
                    }
                })
            })
        };

        (<any>window).initializeSendMeetupForm  = ()=> {
            bindMeetupTabFunction();
        }

        bindMeetupTabFunction();
        //TODO: Rebind
    }

    //#endregion

    //#region Banner

    bindDeadlineBanner(bannerElement: JQuery<HTMLElement>, challengeForm : any, deadlineExpiredFunc : (status: ConceptStatus) => void) {
        var self = this;

        var challengeHeader = $('body').find('.challenge-header').first();
        var deadlineYear = challengeHeader.data('deadline-year'); 
        var deadlineMonth = challengeHeader.data('deadline-month'); 
        var deadlineDay = challengeHeader.data('deadline-day'); 
        var deadlineHour = challengeHeader.data('deadline-hour'); 
        var deadlineMinute = challengeHeader.data('deadline-minute'); 
        
        var deadlineMinutesText = challengeForm.data('minutes-deadline-text'); 
        var deadlineSecondsText = challengeForm.data('seconds-deadline-text'); 
        
        var deadlineDateTime = new Date(deadlineYear, deadlineMonth-1, deadlineDay, deadlineHour, deadlineMinute);

        var dutchTimeZoneDate = new Date();
        dutchTimeZoneDate = DateHelper.changeTimezone(dutchTimeZoneDate, "Europe/Amsterdam")

        var currentDateTime = dutchTimeZoneDate.getTime();
        var deadlineTime  = deadlineDateTime.getTime();

        if(currentDateTime < deadlineTime) {
            challengeHeader.before(bannerElement);
        }
        else {
            bannerElement.remove();
            return;
        }

        const initializeBanner= () => {
            var fillerElement = bannerElement.find('.topbottom-banner-filler');
            var contentElement = bannerElement.find('.topbottom-banner-content');
            var deadlineTextContainer = contentElement.find('.inner-content').children().first();
            var dismissButton = bannerElement.find('.banner-dismiss-button');

            var displayFunction = () => {
                bannerElement.css('display', 'initial');
            };

            var difference = deadlineTime - currentDateTime;
            var differenceInDays = DateHelper.dateDifferenceInDays(dutchTimeZoneDate, deadlineDateTime);
            var differenceInHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var differenceInMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            var differenceInSeconds = Math.floor((difference % (1000 * 60)) / 1000);


            var updateDeadlineTextAndTime = () => {
                difference = deadlineTime - DateHelper.changeTimezone(new Date(), "Europe/Amsterdam").getTime();
                differenceInDays = DateHelper.dateDifferenceInDays(dutchTimeZoneDate, deadlineDateTime);
                differenceInHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                differenceInMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                differenceInSeconds = Math.floor((difference % (1000 * 60)) / 1000);

                var text = '';
                if(differenceInMinutes >= 1) {
                    var minutesText = deadlineMinutesText;
                    if(differenceInMinutes == 1) {
                        minutesText = minutesText.replace('minuten', 'minuut');
                        minutesText = minutesText.replace('minutes', 'minute');
                    }
                    text = minutesText.replace('<XX>', differenceInMinutes)
                }
                else {
                    var secondsText = deadlineSecondsText;
                    text = secondsText.replace('<XX>', ("0" + differenceInSeconds).slice(-2))
                }
                deadlineTextContainer.text(text); 
            }
            
            var startCountdownFunc = () => {
                var deadlineCountdownInterval = setInterval(function () {
                    currentDateTime = DateHelper.changeTimezone(new Date(), "Europe/Amsterdam").getTime();
                    updateDeadlineTextAndTime();

                    if(currentDateTime >= deadlineTime) {
                        clearInterval(deadlineCountdownInterval);
                        bannerElement.remove();

                        var conceptStatusValue = $('#submission-status').val();
                        var conceptStatus = ConceptStatus.Concept;
                        if(conceptStatusValue != undefined && conceptStatusValue.toString().length > 0) {
                            if(conceptStatusValue === 'Submitted') {
                                conceptStatus = ConceptStatus.Submitted
                            }
                        }
                        deadlineExpiredFunc(conceptStatus);
                    }
                }, 1000);
            }

            dismissButton.on('click', (e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                var disableTimeout = 200;
                if(contentElement.hasClass('topbottom-banner-closed')) {
                    disableTimeout = 0;
                }

                bannerElement.trigger('mouseleave');
                contentElement.toggleClass('animate');
                setTimeout(() => {
                    bannerElement.remove();
                }, 500)
            })

            var isDisplayed = false;
            if(currentDateTime < deadlineTime) {
                updateDeadlineTextAndTime();
                var countdownToDisplayBanner;
                var updateClock = () => {
                    currentDateTime = DateHelper.changeTimezone(new Date(), "Europe/Amsterdam").getTime()
                    deadlineTime  = deadlineDateTime.getTime()

                    updateDeadlineTextAndTime();

                    if(differenceInDays == 0 && differenceInHours < 1) {
                        if(differenceInMinutes <= 30) {
                            if(!isDisplayed) {
                                isDisplayed = true;
                                displayFunction();
                            }

                            startCountdownFunc();
                            clearInterval(countdownToDisplayBanner);
                        }
                    }
                }
                countdownToDisplayBanner = setInterval(updateClock, 1000);
            }

            var contentElementRects = contentElement[0].getBoundingClientRect();
            fillerElement.css('height', contentElementRects.height);
        
            var firstDivHeight = 0;
            var firstDiv = $('body').find('div:not(.starthubs-header)').first();

            if(firstDiv.length >= 1) {
                var menuRects = firstDiv[0].getBoundingClientRect();
                firstDivHeight = menuRects.height;
            }

            $(window).scroll(function(e){
                var isPositionFixed = (contentElement.css('position') == 'fixed');
                var scrollTop = $(this).scrollTop();

                if (scrollTop > firstDivHeight && !isPositionFixed){ 
                    contentElement.css({'position': 'fixed', 'top': '0px'}); 
                    fillerElement.css('display', 'flex');

                    contentElement.addClass('topbottom-banner-fixed');
                    contentElement.removeClass('topbottom-banner-relative');
                }
                if (scrollTop < firstDivHeight && isPositionFixed){
                    contentElement.addClass('topbottom-banner-relative');
                    contentElement.removeClass('topbottom-banner-fixed');

                    contentElement.css({'position': 'relative', 'top': '0px'});
                    fillerElement.css('display', 'none');
                } 
            });
        }

        initializeBanner();
    }

    //#endregion
}